import React from 'react';
import Header from '../../components/ui/Header';
import Breadcrumb from '../../components/ui/Breadcrumb';
import FilterPanel from '../../components/ui/FilterPanel';
import ContactHealthMetrics from './components/ContactHealthMetrics';
import EngagementMatrix from './components/EngagementMatrix';
import DataQualityDashboard from './components/DataQualityDashboard';
import IntelligentContactGrid from './components/IntelligentContactGrid';

const ContactIntelligenceHub = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <Breadcrumb />
      <FilterPanel />
      
      <main className="main-content">
        <div className="mb-6 md:mb-8">
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-2">
            Intelligence des contacts
          </h1>
          <p className="text-sm md:text-base text-muted-foreground">
            Analytique centralisée et insights d'engagement pour l'optimisation des relations
          </p>
        </div>

        <div className="space-y-6 md:space-y-8">
          <ContactHealthMetrics />

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8">
            <div className="lg:col-span-9">
              <EngagementMatrix />
            </div>
            <div className="lg:col-span-3">
              <DataQualityDashboard />
            </div>
          </div>

          <IntelligentContactGrid />
        </div>
      </main>
    </div>
  );
};

export default ContactIntelligenceHub;